import moment from 'moment';

class GeckoDates {
  /*
   * Format timestamp to local time
   */

  static formatDate(timestamp, format) {
    if (timestamp) {
      let _format = format || 'MMM Do YYYY [at] HH:mm';
      return moment(timestamp, 'X').format(_format);
    }
    return '';
  }

  /*
   * Format timestamp to UTC time
   */

  static formatDateUTC(timestamp, format) {
    if (timestamp) {
      let _format = format || 'MMM Do YYYY [at] HH:mm';
      return moment.utc(timestamp, 'X').format(_format);
    }
    return '';
  }

  /*
   * Format timestamp to specified timezone time
   */

  // static formatDateTimezone(timestamp, timezone format) {

  // }

  static toHumanDate(value) {
    let date = value;
    if (!(date instanceof Date)) {
      try {
        date = new Date(date);
        if (isNaN(date.getTime())) {
          throw new Error();
        }
      } catch (e) {
        throw new Error(
          `Invalid date. Got: ${value} cannot format to human date`
        );
      }
    }
    const evaluateOrdinal = (value) => {
      if (value > 3 && value < 21) return 'th';
      switch (value % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    };

    const day = date.getDate();
    return `${day}${evaluateOrdinal(day)} ${date.toLocaleDateString('en-gb', {
      month: 'long',
    })}, ${date.getFullYear()}`;
  }

  static toHumanDateRange(date1, date2) {
    const humanDate1 = this.toHumanDate(date1).split(' ');
    const humanDate2 = this.toHumanDate(date2).split(' ');

    if (humanDate1.join(' ') === humanDate2.join(' '))
      return humanDate1.join(' ');
    if (humanDate1[2] !== humanDate2[2])
      return `${humanDate1.join(' ')} - ${humanDate2.join(' ')}`;
    if (humanDate1[1] !== humanDate2[1])
      return `${humanDate1[0]} ${humanDate1[1].replace(
        ',',
        ''
      )} - ${humanDate2.join(' ')}`;
    return `${humanDate1[0]} - ${humanDate2.join(' ')}`;
  }
}

export default GeckoDates;
